<template>
    <div id="demo-basic-card" >
        <div id="dashboard-analytics">
            <div class="vx-row">
                <div class="vx-card p-2 pt-0">
                    <div class="vx-row">
                        <div class="vx-col w-full md:w-2/12 mt-2">
                            <vs-button icon-pack="feather" icon = "icon-plus" class="w-full" @click="openModal">{{ $t('add')}}</vs-button>
                        </div>
                        <div class="vx-col w-full md:w-4/12 mt-2">
                            <vs-input class="w-full" v-model="searchData.searchQuery"  v-on:keydown.enter="searchFacebook" :placeholder=" $t('source.sourceList')"></vs-input>
                        </div>
                        <div class="vx-col w-full md:w-2/12 mt-2">
                            <vs-button icon-pack="feather" icon = "icon-upload" class="w-full" @click="importFile" style="background: #8478FF !important;">{{ $t('upload')}}</vs-button>
                        </div>
                        <div class="vx-col w-full md:w-2/12 mt-2">
                            <vs-button class="w-full" @click="exportFileCSV">{{ $t('sampleFile')}} (csv)</vs-button>
                        </div>
                        <div class="vx-col w-full md:w-2/12 mt-2">
                            <vs-button class="w-full" icon-pack="feather" icon = "icon-download" @click="exportCSV">{{ $t('download')}}</vs-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="vx-row mt-4">
                <vs-table stripe :data="rowDatas" :noDataText="this.$t('noData')" class="w-full">
                    <template>
                        <vs-tr style="background:#f3f2f7 !important">
                            <vs-th class="md:w-1/6" v-for="(header, indexHeader) in headerTable" :key="indexHeader">
                                <span>{{header.label}}</span>
                            </vs-th>
                        </vs-tr>
                        <vs-tr v-for="(source, indexSource) in rowDatas.slice(0, pageSize)" :key="indexSource">
                            <vs-td>
                                <span class="text-code ">#{{source.id}}</span>
                            </vs-td>
                            <vs-td>
                                <div class="component">
                                    <span class="text-code">{{source.name}}</span>
                                </div>
                                <div class="component">
                                    <span class="type-source">{{source.type}}</span>
                                </div>
                            </vs-td>
                            <vs-td>
                                <a class="name-source cursor-pointer" @click="openURL(source.url)">{{source.url}}</a>
                            </vs-td>
                            <vs-td>
                                <span class="type-source">{{source.description}}</span>
                            </vs-td>
                            <vs-td>
                                <span
                                class="badge"
                                :style="{background: `rgba(var(--vs-${source.status.bg}),.15)`, color: `${source.status.color}`}">
                                {{source.status.label}}</span>
                            </vs-td>
                            <vs-td>
                                <div class="component inline-image">
                                    <!-- <span class="mr-2">
                                        <img v-if="userInfo.photoURL" key="onlineImg" :src="userInfo.img || userInfo.photoURL" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block" />
                                    </span>
                                    <span class="text-code">{{source.request}}</span> -->
                                </div>
                                <div class="component">
                                    <div class="vx-row">
                                        <div class="vx-col md:w-9/12 w-full">
                                             <span class="type-source">{{source.createdDate}}</span>
                                        </div>
                                        <div class="vx-col md:w-3/12 w-full">
                                            <vs-dropdown class="cursor-pointer">
                                                <feather-icon
                                                icon="MoreVerticalIcon"
                                                class=""
                                                style="color: rgb(110 107 123);width: 1.2rem"
                                                >
                                                </feather-icon>
                                                <vs-dropdown-menu>
                                                <div class="component vx-card">
                                                    <ul style="min-width: 228px">
                                                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="updateFacebook(source)">
                                                        <feather-icon
                                                        icon="EditIcon"
                                                        style="vertical-align:middle;width:1rem"
                                                        >
                                                        </feather-icon>
                                                        <span class="font-action ml-2 mt-1 text-action">{{ $t('source.update')}}</span>
                                                    </li>
                                                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="confirmDeletefacebook(source)">
                                                        <feather-icon
                                                        icon="Trash2Icon"
                                                        style="vertical-align:middle;width:1rem"
                                                        >
                                                        </feather-icon>
                                                        <span class="font-action ml-2 mt-1 text-action">{{ $t('source.delete')}}</span>
                                                    </li>
                                                    </ul>
                                                </div>
                                                </vs-dropdown-menu>
                                            </vs-dropdown>
                                        </div>
                                    </div>
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>

            <div class="vx-row mt-2">
                <div class="vx-card custom-card">
                    <div class="vx-col md:w-1/2 w-full m-auto ml-4">
                        <div class="component">
                            <span class="content-page">{{ $t('source.showing')}}: </span>
                            <span class="text-page">{{countElementPage > 0 ? currentPage :0}} - {{amount + countElementPage}}/{{totalElements}} </span>
                            <span class="content-page">{{ $t('source.content')}}</span>
                        </div>
                    </div>
                    <vs-pagination
                        class="custom-pagination"
                        :total ="totalPages"
                        :max="maxPageNumbers"
                        v-model="currentPage"
                        @change="onChangePage"
                    ></vs-pagination>
                </div>
            </div>

            <vs-popup class="modal-default" :title="null" :active.sync="activeModal">
                <div class="vx-row p-4 pt-0">
                    <div class="vx-col mt-4 w-full label-input">
                        <label for="">{{ $t('source.enterThePath')}}</label>
                        <vs-input v-validate ="'required|url'" class="w-full" v-model="facebook.url" placeholder="https://bookface.com" name="url" @blur="searchFacebookUid"></vs-input>
                        <span class="text-danger text-sm">{{errors.first("url")}}</span>
                    </div>
                    <div class="vx-col w-full mt-2 label-input" v-if="!isUpdate">
                        <label for="">Facebook Id</label>
                        <vs-input min="1" type="number" class="w-full" v-model="facebook.code" :disabled="isUpdate"></vs-input>
                    </div>
                    <div class="vx-col w-full mt-2 label-input" v-if="isUpdate">
                        <label for="">{{ $t('source.requireCode')}}</label>
                        <vs-input class="w-full" v-model="facebook.code" :disabled="isUpdate"></vs-input>
                    </div>
                    <div class="vx-col mt-4 w-full label-input">
                        <div class="vx-row">
                            <div class="vx-col md:w-4/12 w-full">
                                <label for="">{{ $t('source.sourceName')}}</label>
                            </div>
                            <div class="vx-col md:w-8/12 w-full text-label">
                                <label for="">{{ $t('source.textSystem')}}</label>
                            </div>
                        </div>
                        <vs-input class="w-full" v-model="details.name" placeholder="Nhập tên nguồn để dễ nhớ"></vs-input>
                    </div>
                    <div class="vx-col mt-4 w-full label-input">
                        <label for="">{{ $t('source.description')}}</label>
                        <vs-textarea v-validate ="'max:100'" class="w-full" v-model="facebook.description" placeholder = "Mô tả thêm về nguồn này. (Không bắt buộc)" name="description"></vs-textarea>
                        <span class="text-danger text-sm">{{errors.first("description")}}</span>
                    </div>
                    <div class="vx-col mt-4 w-full label-input" >
                        <vs-button class="mr-2" @click="saveChanges" :disabled ="!validateForm">{{isUpdate ? $t('source.update') : $t('source.create')}}</vs-button>
                        <vs-button type='border' @click="activeModal = false">{{ $t('source.close')}}</vs-button>
                    </div>
                </div>
            </vs-popup>

            <vs-popup :active.sync="activeImportExcel">
                <div class="vx-row">
                    <div style="margin:auto">
                        <div class="mb-8">
                            <import-excel :checkImport="checkImportSuccess" :checkImportFail="checkImportFail" :checkFileImport ="removeFileImport" :onSuccess="loadDataInTable" />
                        </div>
                    </div>
                </div>
            </vs-popup>
        </div>
      <PopupConfirm :active="activePopup" :on-success="onSuccess" :close="closePopup"/>
    </div>
</template>
<script>
import {AgGridVue} from "ag-grid-vue";
import ImportExcel from "@/components/excel/ImportExcel.vue";
import moment from 'moment';
import PopupConfirm from "../../v2/notify/PopupConfirm";
import authConfig from '@/../auth_config.json';
export default {
    components: {
        AgGridVue,
        ImportExcel,
        moment,
      PopupConfirm
    },
    data(){
        return {
            checkSearchFbUid:false,
            checkImportSuccess: false,
            checkImportFail: false,
            confirmDelete:false,
            activePopup:false,
            countElementPage: 0,
            pageNumber: 0,
            pageSize: 10,
            amount: 0,
            totalElements:0,
            searchData:{
                searchQuery: ""
            },
            optionalType:[
                {text:'Trang cá nhân',value:'profile'},
                {text:'Trang Facebook',value:'page'},
                {text:'Nhóm Facebook',value:'group'}
            ],
            rowDatas: [],
            source: {},
            isUpdate: false,
            removeFileImport: false,
            facebook: {
                code: null,
                url: null,
                description: null,
                active:false,
                userIds: null,
                type: null,
                name: null,
                status: true,
                priority: 0,
                private: false
            },
            details: {
                name: null,
                location: null,
                gender: null
            },
            //modal
            activeModal: false,
            activeImportExcel: false,
            //pagination
            totalPages: 0,
            maxPageNumbers: 6,
            currentPage: 1,
            //facebook
            searchfacebook: {
                url: null,
                processStatus: null
            },
            //header table
            headerTable: [
                {label: this.$t('source.require').toUpperCase()},
                {label: this.$t('source.sourceName').toUpperCase()},
                {label: this.$t('source.url').toUpperCase()},
                {label: this.$t('source.description').toUpperCase()},
                {label: this.$t('source.status').toUpperCase()},
                {label: this.$t('source.newRequire').toUpperCase()}
            ],
            searchName: null,
        }
    },
    computed: {
        validateForm(){
            return !this.errors.any();
        }
    },
    methods: {
        openURL: function(url){
            window.open(url, '_blank');
        },
        onSuccess(){
          if(this.confirmDelete){
            this.removefacebook();
          }
        },
        closePopup(){
            this.activePopup = false;
            this.confirmDelete = false;
        },
        exportFileCSV: function(){
            const rows = [
                ["STT" , "Link Facebook",  "Type  ( 1 - Personal / 2 - Page / 3 - Group )" ]
            ];
            let csvContent = "data:text/csv;charset=utf-8,";
            rows.forEach(function(rowArray) {
                let row = rowArray.join(",");
                csvContent += row + "\r\n";
            });

            let data = encodeURI(csvContent);

            const filename = 'template-import-facebook.csv';
            const link = document.createElement('a');
            link.setAttribute('href', data);
            link.setAttribute('download', filename);
            link.click();
        },
        importFile: function(){
            this.removeFileImport = false;
            this.activeImportExcel = true;
            document.getElementsByClassName('vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null')[0].style.display = 'none'
            document.getElementsByClassName('vs-popup--header')[0].style.display = 'none'
        },
        loadDataInTable: function({ results, header, meta }){
            this.removeFileImport = true;
            this.checkImportFail = false;
            this.checkImportSuccess = false;
            results = results.filter(el => el.length > 0);
            const payload = [];
            for(let c = 0; c < results.length - 1; c++){
            if (isNaN(results[c][0].trim()) || results[c][2] && ![1, 2, 3].includes(parseInt(results[c][2].trim()))){
                this.checkImportFail = true;
                return this.$vs.notify({
                text:this.$t('adminWs.textIllegalFb'),
                icon:'icon-alert',
                iconPack:'feather',
                color:'danger'
                })
            }
            let item = {
                link: results[c][1].trim(),
                type: this.optionalType[results[c][2].trim() - 1].value
            }
                payload.push(item);
            }
            this.$processor.post(`facebook-queue/create/list`, payload).then(() =>{
                this.checkImportSuccess = true;
                this.activeImportExcel = false;
                this.$vs.loading.close();
                this.getListFacebook()
                return this.$vs.notify({
                    text:this.$t('adminWs.textSuccess'),
                    icon:'icon-alert',
                    iconPack:'feather',
                    color:'primary'
                })
            }).
            catch((err) =>{
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                })
            })
        },
        confirmDeletefacebook(source) {
            this.facebook.code = source.id;
            this.activePopup = true;
            this.confirmDelete = true;
        },
        showDeleteSuccess() {
            this.$store.commit('UPDATE_USER_SUCCESS', true);
            this.$vs.notify({
            color: 'primary',
            text: this.$t('adminFbIcon.textSuccess'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            })
        },

        removefacebook: function(){
            this.$vs.loading();
            let id = this.facebook.code;
            const payload = {
                id : id
            }
            this.$processor.post(`/facebook-queue/delete/${id}`,payload).then(() => {
                this.showDeleteSuccess();
                this.$vs.loading.close();
                this.initScreen();
                this.activePopup = false;
                this.confirmDelete = false;
            }).catch((err) => {
                this.$vs.loading.close();
                this.activePopup = false;
                this.confirmDelete = false;
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        updateFacebook: function(source){
            this.activeModal = true;
            this.isUpdate = true;
            const payload = {
                id: source.id
            }
            this.$processor.post('/facebook-queue/find-by-id',payload).then((response) =>{
            let data = response.data;
            let dataForm = JSON.parse(data.details);
            this.facebook.code = data.id;
            if (dataForm) {
                this.details.name = dataForm.name;
                this.details.location = dataForm.location ? dataForm.location.name : "";
                this.details.gender = dataForm.gender;
            }
            this.facebook.status = data.status;
            if(data.type == 'profile'){
                this.facebook.type = this.$t('adminFbIcon.profilePage')
            };
            if(data.type == 'page'){
                this.facebook.type = this.$t('adminFbIcon.pageFb')
            }if(data.type == 'group'){
                this.facebook.type = this.$t('adminFbIcon.groupFb')
            }
            this.facebook.private = data.private;
            this.facebook.priority = data.priority;
            this.facebook.url = data.link;
            this.facebook.description = data.metadata;
            this.isUpdate = true;
            })
            .catch((err) =>{
            return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
            });
        },
        searchFacebook(){
            this.getListFacebook().then(()=> {
            });
        //     const payload = {
        //     facebookQueueDTO: {
        //         modifiedBy: this.searchData.searchQuery
        //     },
        //     pageNumber: 0,
        //     pageSize: 20
        // }
        // this.$processor.post('/facebook-queue/range', payload).then((res) => {

        // })
        //   this.getListFacebook()
        },
        getListFacebook(){
            this.$vs.loading();
            let payload ={
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                searchQuery: this.searchData.searchQuery
            };
            return new Promise((resolve,reject) => {
                this.$processor.post('/facebook-queue/range',payload).then((response) =>{
                    this.countElementPage = response.data.content.slice(0, 10).length;
                    this.amount = response.data.pageable.offset;
                    this.rowDatas = response.data.content.map(el => {
                        let object = {};
                        let details = JSON.parse(el.details);
                        object['id'] = el.id;
                        object['name'] = details ? details.name: "";
                        object['url'] = el.link.split("?")[0];
                        object['description'] = el.metadata;
                        el.status = el.status ? 0 : 1;
                        object['request'] = el.createdBy;
                        object['createdDate'] = el.createdDate ? moment(el.createdDate).format('DD/MM/YYYY hh:mm:ss') : "";
                        let status = {
                            label: null,
                            color: null,
                            bg: null
                        }

                        if (el.status == 0){
                            status.label = this.$t('source.gettingData');
                            status.color = '#2F80ED';
                            status.bg = 'primary';
                            object['status'] = status;
                        }
                        else if (el.status == 1){
                            status.label = this.$t('source.received');
                            status.color = '#FEC400';
                            status.bg = "warning"
                            object['status'] = status;
                        }else{
                            status.label = this.$t('source.other');
                            status.color = '#F12B2C';
                            status.bg = "danger"
                            object['status'] = status;
                        }

                        if (el.type == "profile") object['type'] = this.$t('source.profile');
                        if (el.type == "page") object['type'] = this.$t('source.fanpage');
                        if (el.type == "group") object['type'] = this.$t('source.group');
                        return object;
                    });
                    this.totalPages = parseInt(response.data.totalPages,10);
                    this.pagenumbers = response.data.pageable.pageNumber;
                    this.totalElements = response.data.totalElements;
                    this.$vs.loading.close();
                    resolve();
                }).
                catch((e) =>{
                    ;reject()})
            })

        },
        removeButtonClose: function(){
            document.getElementsByClassName('vs-icon notranslate icon-scale vs-popup--close vs-popup--close--icon material-icons null')[0].style.display = 'none'
            document.getElementsByClassName('vs-popup--header')[0].style.display = 'none'
        },
        openModal: function(){
            this.activeModal = true;
            this.isUpdate = false;
            this.facebook.code = null;
            this.details.name = null;
            this.facebook.url = null;
            this.facebook.description = null;
            this.$validator.reset();
            // this.removeButtonClose();
        },
        onChangePage: function(event){
            const page = String(event);
            this.pageNumber = parseInt(page) - 1
            this.getListFacebook();
        },
        searchFacebookUid(){
            let name = '';
            const payload ={
                fburl: this.facebook.url
            }
            this.$vs.loading();
            this.$processor.post('/facebook-queue/get-facebook-id',payload).then((res) =>{
                this.$vs.loading.close();
                let result = res.data;
                if(result.name){
                    this.checkSearchFbUid = true;
                    this.details.name = result.name;
                    this.facebook.code = result.uid;
                    this.facebook.type = result.type;
                }

            }).
            catch((err) =>{
                this.$vs.loading.close();
                return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        async saveChanges(event){
            if (!this.checkSearchFbUid) this.facebook.type='profile'
            event.preventDefault();
            if(!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;
            this.$vs.loading();
            if (!this.checkSearchFbUid) {
                let name = this.facebook.url.split('//').pop().split();
                if(!this.details.name){
                    this.details.name = name;
                }
            }

            let path = this.isUpdate ? `/facebook-queue/update/${this.facebook.code}` : '/facebook-queue/create';
            const payloadCreate ={
                uid: this.facebook.code,
                type:this.facebook.type,
                status:this.facebook.status,
                private:this.facebook.private,
                priority:this.facebook.priority,
                link:this.facebook.url,
                details: JSON.stringify(this.details),
                metadata: this.facebook.description

            };
            const payloadUpdate =
            {
                uid: this.facebook.code,
                type:this.facebook.type,
                status:this.facebook.status,
                private:this.facebook.private,
                priority:this.facebook.priority,
                link:this.facebook.url,
                details: JSON.stringify(this.details),
                metadata: this.facebook.description
            };
            let payload = this.isUpdate ? payloadUpdate:payloadCreate;
            this.$processor.post(path,payload).then(() =>{
            // this.source = response.data;
            this.$vs.loading.close();
            this.activeModal = false;
            this.facebook.code = null;
            this.details.name = null;
            this.facebook.url = null;
            this.facebook.description = null;
            this.details.gender = null;
            this.details.name = null;
            this.details.location= null;
            this.initScreen();
            this.$vs.notify({
                text: ` ${this.isUpdate ? this.$t('facebookManager.sentRequestUpdate') : this.$t('facebookManager.sentRequestCreate')} `,
                color:'primary',
                icon:'icon-alert-circle',
                iconPack:'feather'
            });
            }).catch((err) =>{
            this.$vs.loading.close();
                return this.$vs.notify({
                text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        getImage: function(){
            this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, JSON.parse(localStorage.getItem('userInfo')));
            const data = localStorage.getItem('userInfo');
            const info = JSON.parse(data);
            if(info.img){
            this.userInfo.img = info.img;
            }
        },
        exportCSV: function(){
            this.$processor.post('/facebook-queue/export-csv', {}).then((response) => {
                this.$vs.loading.close();
                if (!response || !response.data) return this.$vs.notify({
                text: this.$t('createReportError'),
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
                });
                window.open(authConfig.reportDomain + "download/" + response.data + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                return this.$vs.notify({
                    text:'Xuất báo cáo thành công',
                    icon:'icon-alert',
                    iconPack:'feahter',
                    color:'color'
                })
            })
        },
        initScreen(){
            this.getImage();
            this.getListFacebook();
        }
    },
    async created(){
        this.initScreen();
        this.$eventBus.$on('i18n', (event) =>{
            this.initScreen();
            this.headerTable = [
                {label: this.$t('source.require').toUpperCase()},
                {label: this.$t('source.sourceName').toUpperCase()},
                {label: this.$t('source.url').toUpperCase()},
                {label: this.$t('source.description').toUpperCase()},
                {label: this.$t('source.status').toUpperCase()},
                {label: this.$t('source.newRequire').toUpperCase()}
            ]
        })
    },
    mounted(){
    }
}
</script>
<style lang="scss">
.align-download {
    position: absolute;
    right: 10px;
}
.con-vs-popup .vs-popup {
    width: 445px;
    // min-height: 500px;
}
.label-input{
    color: #6E6B7B;
    font-size: 14px;
}
.text-label {
    font-size: 12px;
    color: #B9B9C3;
    text-align: right;
}
.badge {
    padding: .3rem .5rem;
    text-align: center;
    border-radius: .358rem;
    font-weight: 400 !important;
}
.text-code {
    font-size: 14px;
    color: #6E6B7B;
    font-weight: bold;
}
.type-source {
    color: #B9B9C3;
    font-size: 12px;
}
.name-source {
    font-size: 14px;
    color: #6E6B7B;
}
.inline-image {
    display: flex;
}
.text-page {
    font-size: 14px;
    color: #3ba1ff;
}
.content-page {
    color: #caccd6;
    font-size: 14px;
}
.custom-pagination {
    width: 50% !important;
}
.custom-card {
    height: 50px;
    display: flex !important;
    -webkit-box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 2%) !important;
}
.margin-top {
    margin-top: -18px;
}
::placeholder {
  color: #9e9e9e;
  font-size: 12px;
}
.text-action {
    font-size: 12px;
}
.vs-con-table{
  z-index: 1;
}
</style>
